import { getMarketingConsents } from 'redux/modules/marketing-preferences/selectors/get-consents';

const marketingConsents = state => ({
  event: 'marketing_consent_updated',
  marketingConsents: getMarketingConsents(state),
});

export { marketingConsents };
